<template>
    <div class="position-relative">
        <client-header :image="tracking"></client-header>
        <div class="position-lg-absolute w-100" style="bottom: -15%;">
            <client-search class-body="rounded shadow bg-white" to="ClientLocator" width="87%"></client-search>
        </div>
    </div>
</template>
<script>
import tracking from '@/assets/icons/tracking.svg'
export default {
  data: () => ({
    tracking
  })
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/Client.vue